import { Link } from "react-router-dom";

export const Field = ({ id, label, error, required, hint, children }) => (
  <div>
    <label htmlFor={id} className="block font-semibold text-navy mb-2">
      {label} {required && <span className="text-brand-ink" aria-hidden="true">*</span>}
    </label>
    {hint && <p id={`${id}-hint`} className="text-sm text-slate-600 -mt-1 mb-2">{hint}</p>}
    {children}
    {error && <p id={`${id}-error`} role="alert" data-testid={`error-${id}`} className="mt-2 text-[15px] font-medium text-red-700">{error}</p>}
  </div>
);

export const inputProps = (id, errors, extra = {}) => ({
  id, name: id,
  className: `field-input ${errors[id] ? "field-error" : ""}`,
  "aria-invalid": errors[id] ? "true" : "false",
  "aria-describedby": errors[id] ? `${id}-error` : undefined,
  "data-testid": `input-${id}`,
  ...extra,
});

export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
    <label htmlFor="website">Ne pas remplir ce champ</label>
    <input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" value={value} onChange={onChange} data-testid="input-honeypot" />
  </div>
);

export const Consent = ({ checked, onChange, error }) => (
  <div>
    <label htmlFor="consent" className="flex gap-3 items-start cursor-pointer">
      <input id="consent" type="checkbox" checked={checked} onChange={onChange} data-testid="input-consent"
        aria-invalid={error ? "true" : "false"} aria-describedby={error ? "consent-error" : undefined}
        className="mt-1 h-6 w-6 rounded border-2 border-slate-400 accent-[#2E5683] shrink-0" />
      <span className="text-[15px] text-slate-700">
        J'accepte que les informations saisies soient utilisées par Habitalys pour traiter ma demande et me recontacter. Elles ne sont ni cédées ni revendues.{" "}
        <Link to="/confidentialite" className="link-u text-navy font-semibold">Politique de confidentialité</Link>. <span className="text-brand-ink" aria-hidden="true">*</span>
      </span>
    </label>
    {error && <p id="consent-error" role="alert" data-testid="error-consent" className="mt-2 text-[15px] font-medium text-red-700">{error}</p>}
  </div>
);

export const CONSENT_MSG = "Merci d'accepter le traitement de vos données.";
